import { createApi } from '@reduxjs/toolkit/query/react';
import { getCompany } from '../../graphql';
import type { GetCompanyQuery } from '../../graphql/API';
import { baseQuery } from '../../utils';

export const getCompanyApi = createApi({
  reducerPath: 'getCompanyData',
  baseQuery,
  tagTypes: ['GetCompanyData'],
  endpoints: (builder) => ({
    fetchGetCompany: builder.query<GetCompanyQuery['getCompany'], void>({
      query: () => ({ body: getCompany }),
      transformResponse: (response: GetCompanyQuery) => response?.getCompany ?? [],
      providesTags: ['GetCompanyData'],
    }),
  }),
});

export const { useFetchGetCompanyQuery } = getCompanyApi;

